

import {endpoints} from './endpoints'
import request from '../../request'

export function createCommunication(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createCommunication,
			method: 'post',
			data
		})
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function search(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.search,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getParentElement(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getParentElement,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getNotifications(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getNotifications,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function markNotificationAsReaded(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.markNotificationAsReaded,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getReminders() {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getReminders,
			method: 'post'
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getSystemCurrencies() {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getSystemCurrencies,
			method: 'get'
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setUserAvoidEmails(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setUserAvoidEmails,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getUserAvoidEmailsOptions(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getUserAvoidEmailsOptions,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setUserProjectNotificationsConfig(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setUserProjectNotificationsConfig,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}